import { VoiceFormFields } from "./types";

export const CLONE_VOICE_FORM_FIELDS_PLACEHOLDER = {
  [VoiceFormFields.VOICE_NAME]: "Calm Person",
  [VoiceFormFields.DESCRIPTION]: "Relaxing soothing person",
  [VoiceFormFields.LANGUAGE]: "Select a Language...",
};

export const cloneVoiceRequiredFields = [VoiceFormFields.VOICE_NAME, VoiceFormFields.DESCRIPTION, VoiceFormFields.LANGUAGE];

export const CUSTOM_VOICES_LIMIT_ERROR_CODE = "SC-001-6621";
export const VOICE_CREATION_RATE_LIMIT_ERROR_CODE = "SC-001-5201";

export const VOICE_NAME_MAX_LENGTH = 20;
export const DESCRIPTION_MIN_LENGTH = 3;
export const VOICE_NAME_MIN_LENGTH = 3;
export const DESCRIPTION_MAX_LENGTH = 100;
